import React from "react";
import cross_icon from "../../../assets/icons/cross_icon.png";

const SubscriptionHistoryModal = ({ CloseModal }) => {
  return (
    <>
      <div className={`modal-wrapper overflow-y-auto h-full}`}>
        <div className={`side-modal w-[50%] h-screen}`}>
          <div className="flex mt-10 justify-center">
            <div className="flex w-[70%] justify-between">
              <p className="text-[#2F80ED]">
                Subscription History of Westside{" "}
              </p>
              <div onClick={CloseModal} className="cursor-pointer">
                <img src={cross_icon} alt="cross" />
              </div>
            </div>
          </div>
          <div className="flex mt-4 mb-8 justify-center">
            <div className="flex w-[70%] justify-between">
              <p className="text-[#828282] text-[18px]">
                Transaction ID- 12S33ES456F
              </p>
            </div>
          </div>

          <div className="mb-10">
            <div className="flex justify-between items-center rounded-2xl w-[90%] shadow-md p-4 my-8 cursor-pointer ml-8">
              <p className="text-[18px] ml-2">Organiser Pro</p>
              <p className="text-[14px] text-[#828282]">19th October 2023</p>
            </div>
            <div className="flex justify-between items-center rounded-2xl w-[90%] shadow-md p-4 my-8 cursor-pointer ml-8">
              <p className="text-[18px] ml-2">Essential Exhibition Package</p>
              <p className="text-[14px] text-[#828282]">19th October 2023</p>
            </div>
            <div className="flex justify-between items-center rounded-2xl w-[90%] shadow-md p-4 my-8 cursor-pointer ml-8">
              <p className="text-[18px] ml-2">Essential Exhibition Package</p>
              <p className="text-[14px] text-[#828282]">19th October 2023</p>
            </div>
            <div className="flex justify-between items-center rounded-2xl w-[90%] shadow-md p-4 my-8 cursor-pointer ml-8">
              <p className="text-[18px] ml-2">Essential Exhibition Package</p>
              <p className="text-[14px] text-[#828282]">19th October 2023</p>
            </div>
            <div className="flex justify-between items-center rounded-2xl w-[90%] shadow-md p-4 my-8 cursor-pointer ml-8">
              <p className="text-[18px] ml-2">Essential Exhibition Package</p>
              <p className="text-[14px] text-[#828282]">19th October 2023</p>
            </div>
            <div className="flex justify-between items-center rounded-2xl w-[90%] shadow-md p-4 my-8 cursor-pointer ml-8">
              <p className="text-[18px] ml-2">Essential Exhibition Package</p>
              <p className="text-[14px] text-[#828282]">19th October 2023</p>
            </div>
            <div className="flex justify-between items-center rounded-2xl w-[90%] shadow-md p-4 my-8 cursor-pointer ml-8">
              <p className="text-[18px] ml-2">Essential Exhibition Package</p>
              <p className="text-[14px] text-[#828282]">19th October 2023</p>
            </div>
            <div className="flex justify-between items-center rounded-2xl w-[90%] shadow-md p-4 my-8 cursor-pointer ml-8">
              <p className="text-[18px] ml-2">Essential Exhibition Package</p>
              <p className="text-[14px] text-[#828282]">19th October 2023</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionHistoryModal;
